import cx from "classnames";

import { SkeletonProps } from "./types";

import styles from "./styles.module.css";

export function Skeleton({
  isLoading,
  children,
}: SkeletonProps) {
  if (!isLoading) return <>{children}</>;

  return (
    <div aria-busy={isLoading} className={cx({ [styles.loading]: isLoading })}>
      {children}
    </div>
  );
}
